import ReactDOM from 'react-dom/client'
import App from './App'
import 'antd/dist/reset.css'

import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import localeEn from './assets/locales/en/translation.json';
import localeFr from './assets/locales/fr/translation.json';
import localeZh from './assets/locales/zh/translation.json';
import 'flatpickr/dist/flatpickr.min.css';
import i18n from 'i18next';
import './styles/main.less'
import './styles/slickgrid.scss'
import 'overlayscrollbars/overlayscrollbars.css';
import './styles/tailwind.css';
import { setEnterpriseTheme, getEnterpriseDefaultTheme } from './utils/enterpriseTheme';

// 根据环境变量设置企业主题和默认主题
// 如果 localStorage 中没有保存的主题，使用企业的默认主题
if (typeof window !== 'undefined') {
  const savedTheme = localStorage.getItem('custom-theme');
  if (!savedTheme) {
    const defaultTheme = getEnterpriseDefaultTheme();
    document.documentElement.setAttribute('data-theme', defaultTheme);
  }
}
setEnterpriseTheme();

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    // backend: {
    //     loadPath: 'assets/locales/{{lng}}/{{ns}}.json',
    // },
    resources: {
      en: { translation: localeEn },
      fr: { translation: localeFr },
      zh: { translation: localeZh }
    },
    lng: 'zh', // 默认语言
    fallbackLng: 'en', // 后备语言
    debug: true,
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
